/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { GitHubProfileSchema } from './gitHubProfileSchema';
import type { StackOverflowUserSchema } from './stackOverflowUserSchema';

/**
 * Live snapshot of a candidate's GitHub and Stack Overflow profiles.
 *
 * Either field may be ``None`` when the candidate has no link for that
 * network or when the upstream call fails (rate-limit, 404, network
 * error). The frontend renders only the blocks that are present.
 */
export interface TechnicalProfileResponse {
  github?: GitHubProfileSchema | null;
  stackoverflow?: StackOverflowUserSchema | null;
}
